import { createContext } from 'react'

const membershipContext = createContext()

export default membershipContext
